import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import { MemoryRouter } from "react-router-dom";
import MainRoutes from "./pages/routes/routes";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const App = () => {
  const [isNewVersion, setIsNewVersion] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const currentVersion = localStorage.getItem("appVersion");
        const response = await fetch("/version.json", { cache: "no-store" });
        const { version: latestVersion } = await response.json();

        if (currentVersion && currentVersion !== latestVersion) {
          setIsNewVersion(true); // 🚀 Show update notification
        }
        localStorage.setItem("appVersion", latestVersion);
      } catch (error) {
        console.error("Error checking app version:", error);
      }
    };

    checkVersion();
  }, []);

  return (
    <>
      {isNewVersion && (
        <div className="update-banner">
          A new version is available!{" "}
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      )}
      <MemoryRouter>
        <MainRoutes />
      </MemoryRouter>
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();

reportWebVitals();
